/* eslint-disable */

/**
 * 判断浏览器版本
 * @returns {*}  -1，不是ie浏览器。11，IE11。
 * @constructor
 */
export function getIEVersion() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
            return 7;
        } else if (fIEVersion == 8) {
            return 8;
        } else if (fIEVersion == 9) {
            return 9;
        } else if (fIEVersion == 10) {
            return 10;
        } else {
            return 6; //IE版本<=7
        }
    } else if (isEdge) {
        return 'edge'; //edge
    } else if (isIE11) {
        return 11; //IE11
    } else {
        return -1; //不是ie浏览器
    }
}

export function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export function rangeArray(len) {
    return Array.from(Array(len).keys())
}

/**
 * 合并数组并去重
 * @param  {Array} args 需要合并的数组
 * @return {Array}         返回合并后的数组
 */
export function concatArray(...args) {
    const arr = Array.prototype.concat.apply([], args)
    return Array.from(new Set(arr))
}

export function trim(str) {
  return typeof str === 'string' ? str.replace(/(^\s*)|(\s*$)/g, "") : str
}

export function hasScrollbar() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)
}

/**
 * urlToList
 * /userinfo/2144/id => ['/userinfo', '/useinfo/2144', '/userindo/2144/id']
 * @param  {String} url
 * @return {Array}
 */
export function urlToList(url) {
  const urls = url.split('/').filter(i => i)
  return urls.map((urlItem, index) => `/${urls.slice(0, index + 1).join('/')}`)
}

/**
 * 获取字符串长度，中文+2
 */
export function getStringLength(str) {
    if (!str || typeof str !== 'string') {
        return 0
    }
    return str.replace(/[^\x00-\xff]/g, '01').length
}

/**
 * antd Form Validator
 * 字符长度校验，中文按2位计算，并且判断是否为required
 * @param  {Number}   length   最大长度
 * @param  {Object}   rule     原validator rule
 * @param  {String}   value    原validator value
 * @param  {Function} callback 原validator callback
 */
export function validateStringLength(rule, value, callback) {
    if ((rule.required && !trim(value)) || (rule.length && getStringLength(value) > rule.length)) {
        callback(rule.message)
    }
    callback()
}

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
export function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return false
    }

    // 普通的对象while循环结束后proto的值是：Object.prototype，
    // 通过Object.create(null)生成的对象proto的值是：null
    // 不直接使用 Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null 判断
    // 是为了防止一些边界情况的出现，如frame访问变量时
    let proto = obj
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto)
    }

    return Object.getPrototypeOf(obj) === proto
}

/**
 * 去除 data 所有的属性值的空格，不考虑深层次属性，主要用于表单提交
 */
export function trimFieldValues(data) {
    if (data && isPlainObject(data)) {
        const newData = {}
        for (let key in data) {
            newData[key] = trim(data[key])
        }
        return newData
    }
    return data
}
